/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Import_Export_TitleInputs */



/**
* | output |
* | --- |
* | "Importing & Exporting" |
*
* @param {Help_Article_Import_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_import_export_title = /** @type {((inputs?: Help_Article_Import_Export_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Import_Export_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Importieren & Exportieren")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer et exporter")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("导入与导出")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("匯入與匯出")
	if (locale === "ko") return /** @type {LocalizedString} */ ("가져오기와 내보내기")
	return /** @type {LocalizedString} */ ("Importing & Exporting")
});